export const open_configured_dialog = () => ({
    type: 'CONFIGURED_DIALOG__OPEN',
});
export const close_configured_dialog = () => ({
    type: 'CONFIGURED_DIALOG__CLOSE',
});
